Vue.component("MpModal", {

    props: {
        maxWidth: String,
        maxHeight: String,
        type: String
    },

    data: function() {
        return {
            TYPE_A: '',
            TYPE_B: '',
        };
    },

    mixins: [MpScrollTo],

    computed: {
        getModalWidth: function() {
            return (this.maxWidth) ? 'max-width: '+this.maxWidth+';' : '';
        },

        getContentHeight: function() {
            return (this.maxHeight) ? 'max-height: '+this.maxHeight+';' : '';
        },

        // To suppor modifiers through type property
        // getClassType: function() {
        //     var classType;

        //     switch (this.type) {
        //         case this.TYPE_A:
        //             classType = {'--A': true};
        //         break;
        //         case this.TYPE_B:
        //             classType = {'--B': true};
        //         break;
        //     }

        //     return classType;
        // },

        hasHeaderContent: function() {
            return (!!this.$slots.header || !!this.$scopedSlots.header);
        },

        hasActions: function() {
            return (!!this.$slots.actions || !!this.$scopedSlots.actions);
        }
    },
    methods: {
        close: function(ev) {
            if (ev.target.className === 'modal' || ev.currentTarget.className.lastIndexOf('modal__close') >= 0) {
                this.$emit('close');
            }
        },

        onKeyUp: function(event) {
            if (event.code === 'Escape') {
                this.$emit('close');
            }
        },

        init: function() {
            window.addEventListener('keyup', this.onKeyUp);
        },
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    beforeDestroy: function() {
        window.removeEventListener('keyup', this.onKeyUp);
    },

    template: '\
    <div class="modal" @click.prevent="close">\
        <div class="modal__inner" :style="getModalWidth">\
            <a class="modal__close close-btn" href="#" @click.prevent="close">\
                <svg width="12" height="12" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M4 8l4-4 8 8 8-8 4 4-8 8 8 8-4 4-8-8-8 8-4-4 8-8z"/></svg>\
            </a>\
            <div class="modal__header">\
                <slot name="header" v-if="hasHeaderContent">\
                    <h1 class="modal__title">Dummy Header</h1>\
                </slot>\
            </div>\
            <div class="modal__content" :style="getContentHeight">\
                <slot name="content">\
                    <p>Dummy content</p>\
                </slot>\
            </div>\
            <div class="modal__actions" v-if="hasActions">\
                <slot name="actions">\
                    <a class="modal__action btn" href="#">\
                        <span class="btn__icon">\
                            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path class="stroke" d="M17 8.5l-7.5 7L7 13"/><path class="stroke" d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/></g></svg>\
                        </span>\
                        <span class="btn__label">Action 1</span>\
                    </a>\
                    <a class="modal__action btn" href="#">\
                        <span class="btn__icon">\
                            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path class="stroke" d="M17 8.5l-7.5 7L7 13"/><path class="stroke" d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/></g></svg>\
                        </span>\
                        <span class="btn__label">Action 2</span>\
                    </a>\
                </slot>\
            </div>\
        </div>\
    </div>',
});